<template>
  <div>
    <vx-card class="filter-section">
      <div class=" filter-section">
        <vs-divider position="center"><h5>Search Bookings </h5></vs-divider>


        <!-- Date Filter -->
        <div class="mt-4 filter-row">
          <label class="text-sm">Date :</label>
          <datepicker
            class="mb-4"
            label="Date"
            placeholder="Select Date"
            v-model="dateFilter"
          >
          </datepicker>
        </div>

        <!-- Filter Select -->
        <div class="filter-row">
          <label class="text-sm">Filter By :</label>
           <select class="vs__dropdown-toggle v-select" v-model="selectedTextFilter">
            <option class="" disabled value="">Select</option>
            <option style="font-family:'Montserrat'" value="bookingId">Booking ID</option>
            <option value="paymentRef">Payment Reference</option>
          </select>
          <!-- <v-select
            v-model="selectedTextFilter"
            :clearable="true"
            :options="filterOptions"
          /> -->
        </div>

        <!-- Conditional Text Input -->
        <div class="w-auto filter-row" v-if="selectedTextFilter">
          <label class="text-sm">
            Enter
            {{
              selectedTextFilter === "bookingId"
                ? "Booking ID"
                : "Payment Reference"
            }} :
          </label>
          <vs-input
          class="w-auto"
            type="text"
            v-model="textFilterValue"
            :placeholder="
              selectedTextFilter === 'bookingId'
                ? 'e.g. BKG12345'
                : 'e.g. PAY12345'
            "
          />
        </div>

        <!-- Buttons -->
        <div class="filter-row">
          <vs-button
            color="primary"
            @click="searchResults"
            :disabled="loading || (!dateFilter && (!selectedTextFilter || !textFilterValue))"
          >
            Search
          </vs-button>
          <vs-button  :disabled="loading" color="danger" @click="clearFilter" class="clear-btn"
            >Clear Filter</vs-button
          >
        </div>

        <!-- Loading -->
        <div v-if="loading" class="loading-row" aria-live="polite" aria-busy="true">
          <div class="loading-spinner" aria-hidden="true"></div>
          <div class="loading-text">
            <div class="loading-title">Searching bookings…</div>
            <div class="loading-sub">Please wait while we fetch results.</div>
            <div class="loading-bar" aria-hidden="true"></div>
          </div>
        </div>
      </div>
      </vx-card>
      <vs-divider></vs-divider>
      <vx-card>
      <!-- INSERT_YOUR_CODE -->
      <div v-if="Array.isArray(payment) && payment.length === 1 && payment[0] === null">
        <p>No records found.</p>
      </div>
      <!-- Single Result -->
      <div v-else-if="payment && !payments.length && payment !== null">
        <div class="bookings-header">
          <h4 class="bookings-title">Booking Found</h4>
          <span class="bookings-count">
            {{ payment.length }} total
          </span>
        </div>
        <vs-table stripe :data="payment">
          <template slot="thead">
            <vs-th>API BookingID</vs-th>
            <vs-th>Initiated At</vs-th>
            <vs-th>Payment Method</vs-th>
            <vs-th>Receipt ID/ Revolut Order Token</vs-th>
            <vs-th>Payment Reference</vs-th>
            <vs-th class="w-4">Card Payment Status</vs-th>
            <vs-th>Paid At</vs-th>
            <vs-th class="text-right">Amount</vs-th>
            <vs-th class="actions-cell">Actions</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr
              v-for="(tr, indextr) in data"
              v-if="tr && tr.payment && !(Array.isArray(tr.payment) && tr.payment.length === 0)"
              :data="tr"
              :key="indextr"
            >
              <vs-td>{{ tr.api_booking_id }}</vs-td>
              <vs-td>{{ tr.payment.created_at ?   tr.payment.created_at : '-'}}</vs-td>
              <vs-td>{{ tr.payment.processor }}</vs-td>
              <vs-td>{{ tr.payment.receipt_id }}</vs-td>
              <vs-td>{{ tr.payment.payment_reference }}</vs-td>
              <vs-td>
                <div class="status-cell">
                  <vx-tooltip
                    v-if="tr.payment.status == 'pending'"
                    :text="tr.payment.status"
                    color="danger"
                    position="top"
                    delay=".3s"
                  >
                    <feather-icon
                      icon="ZapIcon"
                      :svgClasses="[
                        { 'text-danger': true },
                        'h-5 w-5 stroke-current mt-1',
                      ]"
                      class=""
                    />
                  </vx-tooltip>
                  <vx-tooltip
                    v-if="tr.payment.status == 'paid'"
                    :text="tr.payment.status"
                    color="success"
                    position="top"
                    delay=".3s"
                  >
                    <feather-icon
                      icon="CheckCircleIcon"
                      :svgClasses="[
                        { 'text-success': true },
                        'h-5 w-5 stroke-current mt-1',
                      ]"
                      class=""
                    />
                  </vx-tooltip>
                  <vx-tooltip
                    v-if="tr.payment.status == 'refunded'"
                    :text="tr.payment.status"
                    color="warning"
                    position="top"
                    delay=".3s"
                  >
                    <feather-icon
                      icon="RefreshCcwIcon"
                      :svgClasses="[
                        { 'text-warning': true },
                        'h-5 w-5 stroke-current mt-1',
                      ]"
                      class=""
                    />
                  </vx-tooltip>
                  <vx-tooltip
                    v-if="tr.payment.status == 'cancelled'"
                    :text="tr.payment.status"
                    color="error"
                    position="top"
                    delay=".3s"
                  >
                    <feather-icon
                      icon="XCircleIcon"
                      :svgClasses="[
                        { 'text-error': true },
                        'h-5 w-5 stroke-current mt-1',
                      ]"
                      class=""
                    />
                  </vx-tooltip>
                  <span
                    class="status-pill"
                    :class="'status-' + tr.payment.status"
                  >
                    {{ tr.payment.status }}
                  </span>
                </div>
              </vs-td>
              <vs-td>{{ tr.payment.paid_at ? tr.payment.paid_at : '-'}}</vs-td>
              <vs-td class="text-right">{{ tr.payment.amount }} GBP</vs-td>
              <vs-td class="actions-cell">
                <vs-button
                  v-if="
                    refundAllowed &&
                    tr.payment.status == 'paid' &&
                    tr.payment.receipt_id
                  "
                  color="warning"
                  class=""
                  size="small"
                  @click.stop="openAlert(indextr)"
                >
                  Refund
                </vs-button>
                <vs-button
                  v-if="tr.payment.status == 'paid'"
                  color="purple"
                  class="ml-2"
                  size="small"
                  @click.stop="openEmailAlert(indextr,'single')"
                >
                  Get Receipt
                </vs-button>
                <vs-button
                  v-else-if="tr.payment.status == 'refunded'"
                  class=""
                  color="green"
                  size="small"
                >
                  Refunded
                </vs-button>
                <vs-button
                  v-else-if="
                    (tr.payment.status == 'pending' ||
                      tr.payment.status == 'cancelled') &&
                    !tr.payment.receipt_id
                  "
                  disabled
                  class="pl-3 pr-3"
                  color="grey"
                  size="small"
                >
                  No Receipt ID
                </vs-button>
                <vs-button
                  v-if="
                    (tr.payment.status == 'pending' ||
                      tr.payment.status == 'cancelled') &&
                    !tr.payment.receipt_id
                  "
                  color="primary"
                  class="ml-1 pl-2 pr-2"
                  size="small"
                  @click.stop="openSMSAlert(indextr)"
                >
                  Resend Payment link
                </vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>

      <!-- Paginated List -->
      <div v-if="payments.length">
        <div class="bookings-header">
          <h4 class="bookings-title">Bookings</h4>
          <span class="bookings-count">
            {{ payments.length }} total
          </span>
        </div>
        <vs-table stripe :data="payments">
          <template slot="thead">
            <vs-th>API BookingID</vs-th>
            <vs-th>Initiated At</vs-th>
            <vs-th>Payment Method</vs-th>
            <vs-th>Receipt ID/ Revolut Order Token</vs-th>
            <vs-th>Payment Reference</vs-th>
            <vs-th class="w-4">Card Payment Status</vs-th>
            <vs-th>Paid At</vs-th>
            <vs-th class="text-right">Amount</vs-th>
            <vs-th class="actions-cell">Actions</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>{{ tr.api_booking_id }}</vs-td>
              <vs-td>{{ tr.payment.created_at ? tr.payment.created_at : '-'}}</vs-td>
              <vs-td>{{ tr.payment.processor }}</vs-td>
              <vs-td>{{ tr.payment.receipt_id }}</vs-td>

              <vs-td>{{ tr.payment.payment_reference }}</vs-td>
              <vs-td>
                <div class="status-cell">
                  <vx-tooltip
                    v-if="tr.payment.status == 'pending'"
                    :text="tr.payment.status"
                    color="danger"
                    position="top"
                    delay=".3s"
                  >
                    <feather-icon
                      icon="ZapIcon"
                      :svgClasses="[
                        { 'text-danger': true },
                        'h-5 w-5 stroke-current mt-1',
                      ]"
                      class=""
                    />
                  </vx-tooltip>
                  <vx-tooltip
                    v-if="tr.payment.status == 'paid'"
                    :text="tr.payment.status"
                    color="success"
                    position="top"
                    delay=".3s"
                  >
                    <feather-icon
                      icon="CheckCircleIcon"
                      :svgClasses="[
                        { 'text-success': true },
                        'h-5 w-5 stroke-current mt-1',
                      ]"
                      class=""
                    />
                  </vx-tooltip>
                  <vx-tooltip
                    v-if="tr.payment.status == 'refunded'"
                    :text="tr.payment.status"
                    color="warning"
                    position="top"
                    delay=".3s"
                  >
                    <feather-icon
                      icon="RefreshCcwIcon"
                      :svgClasses="[
                        { 'text-warning': true },
                        'h-5 w-5 stroke-current mt-1',
                      ]"
                      class=""
                    />
                  </vx-tooltip>
                  <vx-tooltip
                    v-if="tr.payment.status == 'cancelled'"
                    :text="tr.payment.status"
                    color="error"
                    position="top"
                    delay=".3s"
                  >
                    <feather-icon
                      icon="XCircleIcon"
                      :svgClasses="[
                        { 'text-error': true },
                        'h-5 w-5 stroke-current mt-1',
                      ]"
                      class=""
                    />
                  </vx-tooltip>
                  <span
                    class="status-pill"
                    :class="'status-' + tr.payment.status"
                  >
                    {{ tr.payment.status }}
                  </span>
                </div>
              </vs-td>
              <vs-td>{{ tr.payment.paid_at ? tr.payment.paid_at : '-'}}</vs-td>
              <vs-td class="text-right">{{ tr.payment.amount }} GBP</vs-td>
              <vs-td class="actions-cell">
                <vs-button
                  v-if="
                    refundAllowed &&
                    tr.payment.status == 'paid' &&
                    tr.payment.receipt_id
                  "
                  color="warning"
                  class=""
                  size="small"
                  @click.stop="openAlert(indextr)"
                >
                  Refund
                </vs-button>
                <vs-button
                  v-if="tr.payment.status == 'paid'"
                  color="purple"
                  class="ml-2"
                  size="small"
                  @click.stop="openEmailAlert(indextr)"
                >
                  Get Receipt
                </vs-button>
                <vs-button
                  v-else-if="tr.payment.status == 'refunded'"
                  class=""
                  color="green"
                  size="small"
                >
                  Refunded
                </vs-button>
                <vs-button
                  v-else-if="
                    (tr.payment.status == 'pending' ||
                      tr.payment.status == 'cancelled') &&
                    !tr.payment.receipt_id
                  "
                  disabled
                  class="pl-3 pr-3"
                  color="grey"
                  size="small"
                >
                  No Receipt ID
                </vs-button>
                <vs-button
                  v-if="
                    (tr.payment.status == 'pending' ||
                      tr.payment.status == 'cancelled') &&
                    !tr.payment.receipt_id
                  "
                  color="primary"
                  class="ml-1 pl-2 pr-2"
                  size="small"
                  @click.stop="openSMSAlert(indextr)"
                >
                  Resend Payment link
                </vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>

        <!-- Simple Pagination -->
        <div class="pagination">
          <button
            :disabled="currentPage <= 1"
            @click="changePage(currentPage - 1)"
          >
            Prev
          </button>
          <span>Page {{ currentPage }}</span>
          <button
            :disabled="!hasMorePages"
            @click="changePage(currentPage + 1)"
          >
            Next
          </button>
        </div>
      </div>

      <!-- No Data -->
      <div v-if="!loading && !payment && !payments.length && searched">
        <p>No records found.</p>
      </div>
    </vx-card>
    <vs-prompt
      title="SMS payment link to customer"
      accept-text="Send"
      @accept="send_sms"
      :active.sync="smsPrompt"
    >
      <div class="con-exemple-prompt">
        Enter the phone number
        <vs-input
          class="w-full mt-2"
          placeholder="+447*******"
          v-model="customer_telephone"
        />
      </div>
    </vs-prompt>
    <vs-prompt
      title="Email to customer"
      accept-text="Send"
      @accept="send_email"
      :active.sync="emailPrompt"
    >
      <div class="con-exemple-prompt">
        Enter email
        <vs-input
          class="w-full mt-2"
          placeholder="john@smith.com"
          v-model="customer_email"
        />
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { _sms_payments } from "@/services/Company";

import { _refundPayment, _getReceipt } from "@/services/Payment";
import { _send_sms } from "@/services/Smspay";
import vSelect from "vue-select";

import Datepicker from "vuejs-datepicker";

export default {
  components: {
    vSelect,
    Datepicker,
  },
  data() {
    return {
      dateFilter: new Date(),
      selectedTextFilter: "",
      textFilterValue: "",
      payment: null,
      payments: [],
      currentPage: 1,
      currentIndex: -1,

      hasMorePages: false,
      loading: false,
      searched: false,
      current_company: this.$store.state.company.companyID,
      filterOptions: [
        { label: "Booking ID", value: "bookingId" },
        { label: "Payment Reference", value: "paymentRef" },
      ],
      emailPrompt: false,
      customer_email: "",
      smsPrompt: false,
      customer_telephone: "",
      resultSet : null
    };
  },
  watch: {
    selectedTextFilter() {
      this.textFilterValue = "";
    },
    "$store.state.company.companyID"(val) {
      this.current_company = val;
    },
  },
  computed: {
    refundAllowed() {
      const localPermission = this.$store.state.AppActiveUser.permissions;
      if (
        Object.keys(localPermission).length === 0 &&
        localPermission.constructor === Object
      )
        return true;
      else {
        if (localPermission.some((p) => p.path.includes("/refund"))) {
          return true;
        }
        return false;
      }
    },
  },
  methods: {
    searchResults(page = 1) {
      if (typeof page !== "number") page = 1;
      this.loading = true;
      this.searched = true;
      this.payment = null;
      this.payments = [];

      this.currentPage = page; // ✅ SET the current page
      const payload = {
        page: page, // ✅ Use the passed page number
        filterType: this.selectedTextFilter || "none",
      };

      if (this.textFilterValue) {
        payload.value = this.textFilterValue;
      }

      if (this.dateFilter) {
          let dateObj = new Date(this.dateFilter);
          const year = dateObj.getFullYear();
          const month = String(dateObj.getMonth() + 1).padStart(2, '0');
          const day = String(dateObj.getDate()).padStart(2, '0');
          payload.date = `${year}-${month}-${day}`;
        }

      _sms_payments(this.current_company, payload, this.currentPage)
        .then((res) => {
          if (res.data.obj.payment) {
            this.payment = res.data.obj.payment;
            this.hasMorePages = false;
            this.resultSet = 'single';
          } else if (res.data.obj.payments) {
            this.resultSet = 'list'
            this.payments = res.data.obj.payments.data || res.data.obj.payments;
            this.hasMorePages =
              res.data.obj.payments.current_page <
              res.data.obj.payments.last_page;
          }
        })
        .catch((err) => {
          console.error("Search error:", err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changePage(page) {
      this.searchResults(page); // ✅ properly pass page number
    },
    clearFilter() {
      this.selectedTextFilter = "";
      this.textFilterValue = "";
      // Optional:
      this.dateFilter = "";
      this.payment = null;
      this.payments = [];
      this.currentPage = 1;
      this.hasMorePages = false;
      this.searched = false;
      this.resultSet = null;

    },
    openAlert(rowIndex) {
      this.currentIndex = rowIndex;
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: `Refund Request`,
        text: "Do you really want to make a refund of this payment?",
        accept: this.doRefund,
        acceptText: "Do Refund",
      });
    },
    openEmailAlert(rowIndex) {
      this.currentIndex = rowIndex;
      if(this.resultSet == 'single')
        this.customer_email = this.payment[rowIndex].customer_email;
      else
        this.customer_email = this.payments[rowIndex].customer_email;

      this.emailPrompt = true;
    },
    openSMSAlert(rowIndex) {
      this.currentIndex = rowIndex;
       if(this.resultSet == 'single')
          this.customer_telephone = this.payment[rowIndex].customer_telephone;
        else
          this.customer_telephone = this.payments[rowIndex].customer_telephone;

      this.smsPrompt = true;
    },
    send_email() {
      if (!this.customer_email)
        return alert("Please enter valid email to get receipt");

      const pr = (this.resultSet == 'single')
                ? this.payment[this.currentIndex].payment.reference_number
                : this.payments[this.currentIndex].payment.reference_number;
      _getReceipt(
        { email: this.customer_email },
        pr
      )
        .then(
          (res) => {
            console.log(res.data);
            alert("email has been sent to your given address");
            this.customer_email = "";
          },
          (error) => {
            this.handleError(error);
          }
        )
        .catch((error) => {
          this.handleCatch(error);
        });
    },
    send_sms() {
      let ride = (this.resultSet == 'single')
                ? this.payment[this.currentIndex]
                : this.payments[this.currentIndex];

      const message =
        "Hello Your ride from " +
        ride.pickup +
        " to " +
        ride.destination +
        " at " +
        ride.order_time +
        " has been booked. Booking Ref:" +
        ride.api_booking_id +
        ". Download the App now: http://bit.ly/2k1PVG0 Would you like a fixed price and pay by card click the link ";
      let data = {
        phonenumber: this.customer_telephone,
        message: message,
        bookingId: ride.api_booking_id,
        generateLink: true,
      };
      this.$vs.loading();
      _send_sms(data)
        .then(
          (res) => {
            this.$vs.notify({
              text: "SMS sent successfully",
              iconPack: "feather",
              icon: "icon-check-circle",
              color: "success",
            });
          },
          (error) => {
            this.handleError(error);
          }
        )
        .catch((error) => {
          this.handleCatch(error);
        })
        .finally(() => this.$vs.loading.close());
    },
    doRefund() {
      let rowIndex = this.currentIndex;
      let obj = (this.resultSet == 'single')
                ? this.payment[rowIndex]
                : this.payments[rowIndex];
      let payment = obj.payment;

      _refundPayment(payment).then(
        (res) => {
          if (this.resultSet == 'single') {
            this.payment[rowIndex].payment.status = "refunded";
          }
          else {
            this.payments[rowIndex].payment.status = "refunded";
          }
          this.$vs.notify({
            title: "Refund",
            text: res.data.message,
            iconPack: "feather",
            icon: "icon-check-circle",
            color: "success",
          });
        },
        (error) => {
          this.$vs.notify({
            title: "Refund",
            text: error.response.data.message,
            iconPack: "feather",
            icon: "icon-cross-circle",
            color: "danger",
            time: 5000,
          });
        }
      );
    },
    handleError(error) {
      if (error.response.status == 422) {
        this.$vs.notify({
          title: "validation",
          text: "Validation Error",
          iconPack: "feather",
          icon: "icon-cross-circle",
          color: "danger",
        });
      } else {
        let errMsg = "";
        let errTitle = "";
        if (error.response.data.responseTitle) {
          errTitle = error.response.data.responseTitle;
          errMsg = error.response.data.responseMessage;
        } else {
          errTitle = "Failed";
          errMsg = error.response.data.message;
        }
        this.$vs.notify({
          title: errTitle,
          text: errMsg,
          iconPack: "feather",
          icon: "icon-cross-circle",
          color: "danger",
        });
      }
    },
    handleCatch(error) {
      this.$vs.notify({
        text: error.message,
        iconPack: "feather",
        icon: "icon-cross-circle",
        color: "danger",
      });
    },
    
  },

};
</script>

<style scoped>
.filter-section {
  max-width: 600px;
  margin: 20px auto;
}
.filter-row {
  margin-bottom: 15px;
}

.bookings-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  margin-bottom: 8px;
}

.bookings-title {
  font-size: 1rem;
  font-weight: 600;
  color: #111827;
  margin: 0;
}

.bookings-count {
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 500;
  color: #1d4ed8;
  background-color: #eff6ff;
  border: 1px solid #bfdbfe;
}

.text-right {
  text-align: right;
}

.actions-cell {
  white-space: nowrap;
}

.status-cell {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 0.75rem;
  text-transform: capitalize;
  border: 1px solid transparent;
}

.status-paid {
  background-color: #ecfdf3;
  border-color: #bbf7d0;
  color: #166534;
}

.status-pending {
  background-color: #fef3c7;
  border-color: #fde68a;
  color: #92400e;
}

.status-refunded {
  background-color: #eff6ff;
  border-color: #bfdbfe;
  color: #1d4ed8;
}

.status-cancelled {
  background-color: #fef2f2;
  border-color: #fecaca;
  color: #b91c1c;
}

label {
  font-weight: bold;
  display: block;
  margin-bottom: 5px;
}
input,
select {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
}
.clear-btn {
  margin-left: 10px;
  background-color: #f87171;
}
.pagination {
  margin-top: 15px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.pagination button {
  padding: 6px 12px;
  font-size: 0.875rem;
  border-radius: 4px;
  border: 1px solid #d1d5db;
  background-color: #ffffff;
  color: #374151;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}
.pagination button:hover:not(:disabled) {
  background-color: #2563eb;
  border-color: #2563eb;
  color: #ffffff;
}
.pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Mature desktop table styling */
::v-deep .vs-table {
  font-size: 0.875rem;
}

::v-deep .vs-table--thead th {
  padding-top: 8px;
  padding-bottom: 8px;
  font-weight: 600;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6b7280;
  background-color: #f9fafb;
}

::v-deep .vs-table tbody td {
  vertical-align: middle;
}

::v-deep .vs-table tbody tr:hover {
  background-color: #f3f4f6;
}

.loading-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-top: 12px;
  padding: 12px;
  border: 1px solid #e5e7eb;
  background: #f9fafb;
  border-radius: 12px;
}

.loading-spinner {
  width: 18px;
  height: 18px;
  border-radius: 999px;
  border: 2px solid rgba(37, 99, 235, 0.2);
  border-top-color: #2563eb;
  animation: tpSpin 0.8s linear infinite;
  margin-top: 2px;
  flex: 0 0 auto;
}

.loading-text {
  flex: 1 1 auto;
}

.loading-title {
  font-weight: 600;
  font-size: 14px;
  color: #111827;
  line-height: 1.2;
}

.loading-sub {
  margin-top: 2px;
  font-size: 12px;
  color: #6b7280;
  line-height: 1.2;
}

.loading-bar {
  position: relative;
  overflow: hidden;
  height: 4px;
  width: 100%;
  margin-top: 10px;
  border-radius: 999px;
  background: #e5e7eb;
}

.loading-bar::before {
  content: "";
  position: absolute;
  left: -40%;
  top: 0;
  height: 100%;
  width: 40%;
  background: linear-gradient(
    90deg,
    rgba(37, 99, 235, 0),
    rgba(37, 99, 235, 0.65),
    rgba(37, 99, 235, 0)
  );
  animation: tpShimmer 1.2s ease-in-out infinite;
}

@keyframes tpSpin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes tpShimmer {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(350%);
  }
}
</style>
